import { render, staticRenderFns } from "./kh.vue?vue&type=template&id=0bae6807&scoped=true&"
import script from "./kh.vue?vue&type=script&lang=js&"
export * from "./kh.vue?vue&type=script&lang=js&"
import style0 from "./kh.vue?vue&type=style&index=0&id=0bae6807&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae6807",
  null
  
)

export default component.exports